const getLocalItem = (key) => {
    try {
        const item = window.localStorage.getItem(key);
        if (item === 'undefined') {
            window.localStorage.removeItem(key);
            return '';
        }
    
        if (item) {
            return JSON.parse(item);
        }
        if (item === '') {
            return '';
        }
        return undefined;
    } catch (error) {
        console.error('getLocalItem error', error);
        return undefined;
    }
};

const setLocalItem = (key, value) => {
    window.localStorage.setItem(key, JSON.stringify(value));
};

const removeLocalItem = (key) => {
    window.localStorage.removeItem(key);
};

const removeLocalAll = () => {
    const filter = getLocalItem('filter');
    // 工作表下筛选缓存
    const settings = getLocalItem('settings');
    window.localStorage.clear();
    if (filter) {
        setLocalItem('filter', filter);
    }
    if (settings) {
        setLocalItem('settings', settings);
    }
};

const getSessionItem = (key) => {
    const item = window.sessionStorage.getItem(key);

    if (item) {
        return JSON.parse(item);
    }

    return undefined;
};

const setSessionItem = (key, value) => {
    window.sessionStorage.setItem(key, JSON.stringify(value));
};

const removeSessionAll = () => {
    window.sessionStorage.clear();
};

// 多层级对象缓存，支持 key 的链式写法
// 应用场景举例：工具库中各个模块的筛选器，toolsFilter.material = {}
const setCacheWithChain = (key, value, isToLocal = true) => {
    if (key.indexOf('.') > -1) {
        const keys = key.split('.');
        const wraperKey = keys[0];
        const wrapperObj = isToLocal ? getLocalItem(wraperKey) || {} : getSessionItem(wraperKey) || {};

        keys.shift();
        setValueObj(wrapperObj, keys, value);

        isToLocal ? setLocalItem(wraperKey, wrapperObj) : setSessionItem(wraperKey, wrapperObj);
        return;
    }

    isToLocal ? setLocalItem(key, value) : setSessionItem(key, value);
};

const setValueObj = (obj, keys, value) => {
    if (!obj) {
        obj = {};
    }

    if (keys.length === 1) {
        obj[keys[0]] = value;
        return obj;
    }

    const wrapKey = keys[0];
    if (!Object.keys(obj).includes(wrapKey)) {
        obj[wrapKey] = {};
    }

    keys.shift();
    obj[wrapKey] = setValueObj(obj[wrapKey], keys, value);
    return obj;
};

const getCacheWithChain = (key, isFromLocal = true) => {
    if (key.indexOf('.') > -1) {
        const keys = key.split('.');

        const wrapperObj = isFromLocal ? getLocalItem(keys[0]) : getSessionItem(keys[0]);
        keys.shift();
        return getValueObj(wrapperObj, keys);
    }

    return getLocalItem(key);
};

// 驼峰转换下划线
function toLine (name) {
    return name.replace(/([A-Z])/g, '_$1').toLowerCase();
}

// 下划线转换驼峰
function toCamel (name) {
    return name.replace(/_(\w)/g, function (all, letter) {
        return letter.toUpperCase();
    });
}

const getValueObj = (obj, keys) => {
    if (!obj || Object.keys(obj).length === 0) {
        return undefined;
    }

    const wrapObj = obj[keys[0]] || obj[toLine(keys[0])] || obj[toCamel(keys[0])];
    if (!wrapObj && wrapObj !== '') {
        return undefined;
    }
    const isObject = Object.prototype.toString.call(wrapObj) === '[object Object]';
    const hasNext =
        keys.length > 1 &&
        Object.keys(wrapObj).filter((i) => [keys[1], toLine(keys[1]), toCamel(keys[1])].includes(i)).length > 0;
    if (isObject && hasNext) {
        keys.shift();
        return getValueObj(wrapObj, keys);
    }

    if (keys.length === 1) {
        return wrapObj;
    }

    return undefined;
};

export default {
    getLocalItem,
    setLocalItem,
    removeLocalItem,
    removeLocalAll,
    getSessionItem,
    setSessionItem,
    removeSessionAll,
    getCacheWithChain,
    setCacheWithChain,
};
